// extracted by mini-css-extract-plugin
export default {"table-container":"ROCsCtGwCS8Gronks7YQ","table-top-right-field":"K8zqkKXSk73bDXhk9pZ2","divider":"IdNqyRimy4hMDtDfo0Pk","table-wrapper":"Hcr3Aw9862esoXHkgrcE"};